import { render, staticRenderFns } from "./ReceivingDataTable.vue?vue&type=template&id=289bf3f3&scoped=true"
import script from "./ReceivingDataTable.vue?vue&type=script&lang=js"
export * from "./ReceivingDataTable.vue?vue&type=script&lang=js"
import style0 from "./ReceivingDataTable.vue?vue&type=style&index=0&id=289bf3f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289bf3f3",
  null
  
)

export default component.exports